import { useTranslation } from "react-i18next";

import type { ProjectStatistics_PlannerVisitFragment } from "../fragments.generated";
import { ProjectVisitListCard } from "./ProjectVisitListCard";

interface ProjectRecentVisitsCardProps {
    visits: ProjectStatistics_PlannerVisitFragment[];
}

export function ProjectRecentVisitsCard({ visits }: ProjectRecentVisitsCardProps) {
    const { t } = useTranslation("project");

    return (
        <ProjectVisitListCard
            href="planned?plannerVisitStatus=approved"
            hrefTitle={t("overviewScreen.recentVisits.link")}
            title={t("overviewScreen.recentVisits.title")}
            visits={visits}
        />
    );
}
